export const translations = {
    fr: {
        moment: {
            relativeTime: {
                future : 'dans %s',
                past : 'il y a %s',
                s : '%d s',
                m : '%d min',
                mm : '%d mins',
                h : '%d h',
                hh : '%d h',
                d : '%d j',
                dd : '%d j',
                M : '%d mois',
                MM : '%d mois',
                y : '%d an',
                yy : '%d ans'
            }
        },
        dateFormat: {
            default: 'DD/MM/YYYY',
            short: 'DD/MM/YY',
            long: '[le] DD/MM/YYYY',
            longer: 'dddd DD MMMM YYYY',
            from: '[du] ddd DD MMM',
            fromLonger: '[du] ddd DD MMM YYYY',
            to: '[au] ddd DD MMM',
            toLonger: '[au] ddd DD MMM YYYY',
            file: 'YYYY-MM-DD'
        },
        timeFormat: {
            default: 'HH[h]mm',
            long: '[à] HH[h]mm',
            from: '[de] HH[h]mm',
            to: '[à] HH[h]mm',
        },
        dateTimeFormat: {
            default: 'DD/MM/YYYY [à] HH[h]mm'
        },
        featureNotImplemented: 'Cette fonctionnalité n’est pas activée pour le moment',
        formInvalid: 'Certains champs du formulaire n\'ont pas été remplis ou sont invalides. Merci de vérifier votre saisie.',
        send: 'envoyer',
        status: 'statut',
        statusEnum: {
            opened: 'en cours',
            closed: 'cloturé'
        },
        currencyEnum: {
            euro: '€'
        },
        description: 'description',
        state: 'état',
        city: 'ville',
        date: 'date',
        distance: 'distance',
        distanceFromTo: 'de {from} à {to}',
        from: 'du',
        to: 'au',
        search: 'recherche',
        stats: 'statistiques',
        address: 'adresse',
        addresses: 'adresses',
        address_es: 'adresse(s)',
        addressNumber: 'numéro',
        addressStreet: 'rue',
        addressZipCode: 'code postal',
        addressCity: 'ville',
        addressBuilding: 'bâtiment',
        addressEntrance: 'entrée',
        addressElevator: 'ascenseur',
        addressStaircase: 'escalier',
        addressFloor: 'étage',
        addressUnit: 'numéro',
        addressDigicode: 'digicode',
        contacts: 'contacts',
        phone: 'tél',
        fax: 'fax',
        email: 'email',
        firstName: 'prénom',
        lastName: 'nom',
        name: 'nom',
        company: 'société',
        reference: 'référence',
        number: 'numéro',
        title: 'titre',
        label: 'label',
        select: 'sélectionner ...',
        comment: 'Commentaire interne non visible par le prestataire',
        instructionsForAssignee: 'Instructions qui seront transmises au prestataire pour le bon déroulement de son intervention',
        callReason: 'raison de l\'appel',
        commentz: 'commenter',
        change: 'modification',
        save: 'sauvegarder',
        next: 'suivant',
        previous: 'précédent',
        validate: 'valider',
        add: 'ajouter',
        update: 'modifier',
        delete: 'supprimer',
        remove: 'supprimer',
        cancel: 'annuler',
        close: 'fermer',
        enable: 'activer',
        disable: 'désactiver',
        associate: 'associer',
        dissociate: 'dissocier',
        assign: 'associer',
        unassign: 'dissocier',
        schedule: 'programmer',
        exportz: 'exporter',
        upgrade: 'souscrire',
        downgrade: 'révoquer',
        corrected: 'édité',
        text: 'texte',
        configs: 'configuration',
        poweredBy: 'Ce service vous est proposé par',
        report: 'rapport',
        selectAll: 'tout sélectionner',
        unselectAll: 'tout désélectionner',
        charge: 'tarif',
        days: 'jours',
        expired: 'expiré',
        processed: 'traité',
        by: 'par',
        showMore: 'voir plus'
    }
}

export default translations.fr


// WEBPACK FOOTER //
// ./lib/i18n.js